module.exports = __webpack_public_path__ + "img/9.46c2bdc6.png";